package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Pomodoro_item(
  public val id: String,
  public val session_id: String,
  public val source_type: String,
  public val source_id: String,
  public val custom_title: String?,
  public val priority: Long,
  public val order_index: Long,
  public val completed: Long,
  public val completed_at: Long?,
  public val estimated_minutes: Long?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
